import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=26dd935f&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dd935f')) {
      api.createRecord('26dd935f', component.options)
    } else {
      api.reload('26dd935f', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=26dd935f&", function () {
      api.rerender('26dd935f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/preview.vue"
export default component.exports